export { default } from './TuitionStatistics';
